import React from 'react';
import { useStats } from 'react-instantsearch';
import ClearAll from '../ClearAll';

const NoResults = () => {
    const { nbHits } = useStats();

    if (nbHits > 0) return null;

    return (
        <div className="grid -col3 -listing">
            <div>
                <h3 className="heading">We could not find what you are looking for</h3>
                <p>
                    Click <ClearAll /> or search for something else.
                </p>
            </div>
        </div>
    );
};

export default NoResults;
